import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { Building2, ArrowLeft, Menu, X } from 'lucide-react'
import GstSidebar from '../../components/dashboard/GstSidebar'
import ConfirmationDialog from '../../components/common/ConfirmationDialog'

const Gstr3BForm = () => {
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Confirmation dialog state
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [pendingNavigation, setPendingNavigation] = useState(null)

  // Navigation confirmation functions
  const handleNavigationAttempt = (path) => {
    // For GSTR3B, we'll always show confirmation since it's a simple form
    setPendingNavigation(path)
    setShowConfirmDialog(true)
  }

  const handleConfirmNavigation = () => {
    if (pendingNavigation) {
      navigate(pendingNavigation)
    }
    setShowConfirmDialog(false)
    setPendingNavigation(null)
  }

  const handleCancelNavigation = () => {
    setShowConfirmDialog(false)
    setPendingNavigation(null)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => handleNavigationAttempt('/gst-dashboard/gstr7')}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            <div className="flex items-center space-x-2">
              <Building2 className="w-8 h-8 text-purple-600" />
              <div>
                <h1 className="text-xl font-semibold text-gray-900">GST Return</h1>
                <p className="text-sm text-gray-500">GSTR3B - Monthly Return</p>
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => {
                localStorage.removeItem('gstr7Data')
                localStorage.removeItem('gstYear')
                localStorage.removeItem('gstMonth')
                localStorage.removeItem('SELECTED_RETURN_TYPE')
                navigate('/')
              }}
              className="flex items-center text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors"
            >
              <X className="w-4 h-4 mr-2" />
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="flex w-full">
        {/* Sidebar */}
        <GstSidebar
          onSidebarStateChange={(state) => setSidebarOpen(state.isOpen)}
          onNavigationAttempt={handleNavigationAttempt}
        />

        {/* Main Content */}
        <main className="flex-1 ml-64 w-full min-w-0">
          <div className="p-2 w-full max-w-none">
            {/* Page Title */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                GSTR3B - Monthly Return
              </h2>
              <p className="text-gray-600">
                This feature is currently under development.
              </p>
            </div>

            {/* Under Development Message */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-8 text-center">
              <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
                <Building2 className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Under Development
              </h3>
              <p className="text-gray-600 mb-4">
                GSTR3B functionality is currently being developed and will be available soon.
              </p>
              <button
                onClick={() => handleNavigationAttempt('/gst-dashboard/gstr7')}
                className="inline-flex items-center px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to GSTR7
              </button>
            </div>
          </div>
        </main>
      </div>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={showConfirmDialog}
        onClose={handleCancelNavigation}
        onConfirm={handleConfirmNavigation}
        title="Confirm Navigation"
        message="Data will get erased. Are you sure you want to move to the other page?"
        confirmText="Yes"
        cancelText="No"
      />
    </div>
  )
}

export default Gstr3BForm
